import React, {
  ChangeEvent,
  CSSProperties,
  useEffect,
  useState,
  useRef,
} from 'react'
import { PartySuggestions, DaDataPartySuggestion } from 'react-dadata'
import $ from 'jquery'
import autosize from 'autosize'
import {
  DefaultProfileType,
  ExternalProfileType,
  UpdateProfileType,
} from '../../containers/SignInPage/types'
import { dadataDots } from '../../utils/helpers'

// Styles
import './styles.scss'
import 'react-dadata/dist/react-dadata.css'

// Icons
import IconEdit from './images/iconEdit'
import IconSave from './images/iconSave'
import IconCancel from './images/iconCancel'

export default ({
  style,
  onSave,
  profile,
  externalProfile,
}: {
  style?: CSSProperties
  onSave: (data: UpdateProfileType) => void
  profile: DefaultProfileType
  externalProfile: ExternalProfileType
}) => {
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const [dadata, setDadata] = useState<DaDataPartySuggestion | undefined>()
  const [group, setGroup] = useState<string>('')
  const [notFilled, setNotFilled] = useState<null | 'edu' | 'group'>()

  const { REACT_APP_DADATA_KEY } = process.env

  const suggestionsRef = useRef<PartySuggestions>(null)

  useEffect(() => {
    const textareaElement = $('.react-dadata__input')
    setTimeout(() => autosize(textareaElement))

    $('.education-edit-block').on('DOMNodeInserted', function (e) {
      if ($(e.target).attr('class') === 'react-dadata__suggestions-outer') {
        $(e.target).parent().find('div:first-child').addClass('active')
      }
    })
    $('.education-edit-block').on('DOMNodeRemoved', function (e) {
      if ($(e.target).attr('class') === 'react-dadata__suggestions-outer') {
        $(e.target).parent().find('div:first-child').removeClass('active')
      }
    })

    return () => {
      autosize.destroy(textareaElement)
    }
  }, [])

  const initialDefaultValues = () => {
    if (profile.school && suggestionsRef.current) {
      suggestionsRef.current.setInputValue(profile.school.value)
      setTimeout(() => autosize.update($('.react-dadata__input')))
    } else {
      if (suggestionsRef.current) suggestionsRef.current.setInputValue('')
      setTimeout(() => autosize.update($('.react-dadata__input')))
    }
    setGroup(profile.school_group || '')
  }

  useEffect(() => {
    initialDefaultValues()
  }, [profile])

  const handleSave = () => {
    if (!dadata) {
      setNotFilled('edu')
      return
    }
    if (!group.length) {
      setNotFilled('group')
      return
    }

    setNotFilled(null)

    if (dadata?.data?.ogrn) {
      const currentRegion = externalProfile.address?.region
      const currentCity = externalProfile.address?.location

      const dadataRegion = dadata?.data?.address?.data.region_with_type

      const dadataCity =
        dadata?.data?.address?.data?.settlement_with_type ||
        dadata?.data?.address?.data?.city_with_type

      onSave({
        school: {
          value: dadata?.value,
          ogrn: dadata?.data?.ogrn,
          city: dadataCity,
        },
        school_group: group,
        external_profile: {
          address: {
            country: 'Россия',
            region: currentRegion
              ? undefined
              : dadataRegion
              ? dadataDots(dadataRegion)
              : undefined,
            location: currentCity
              ? undefined
              : dadataCity
              ? dadataDots(dadataCity)
              : undefined,
          },
        },
      })
    } else {
      onSave({
        school: {
          value: profile.school?.value,
          ogrn: profile.school?.ogrn,
          city: profile.school?.city,
        },
        school_group: group,
      })
    }
    setIsEdit(false)
  }

  const onChangeGroup = (event: ChangeEvent<HTMLInputElement>) => {
    setNotFilled(null)
    setGroup(event.currentTarget.value)
  }

  return (
    <div className={'education-edit-block'} style={style}>
      <div className={'education-edit-block__header'}>
        <span className={'title'}>
          Образовательное
          <br />
          учреждение
        </span>
        <div className={'nav'}>
          {isEdit ? (
            <>
              <IconSave style={{ marginRight: 9 }} onClick={handleSave} />
              <IconCancel
                onClick={() => {
                  setNotFilled(null)
                  setIsEdit(false)
                  initialDefaultValues()
                }}
              />
            </>
          ) : (
            <IconEdit onClick={() => setIsEdit(true)} />
          )}
        </div>
      </div>
      <div className={'education-edit-block__column'}>
        <div className={'education-edit-block__column-field'}>
          <div className={'label'}>
            Образовательное
            <br />
            учреждение:
          </div>
          <div className={dadata ? 'input' : 'input clear'}>
            <PartySuggestions
              token={REACT_APP_DADATA_KEY}
              value={dadata}
              onChange={value => {
                setNotFilled(null)
                setDadata(value)
                setTimeout(() => autosize.update($('.react-dadata__input')))
              }}
              okved={[
                '85.13',
                '85.14',
                '85.21',
                '85.12',
                '85.4',
                '85.41',
                '85.42',
                '85.11',
              ]}
              autoload={true}
              inputProps={{
                disabled: !isEdit,
                style: notFilled === 'edu' ? { border: '1px solid red' } : {},
                onChange: () => setDadata(undefined),
              }}
              ref={suggestionsRef}
              customInput={'textarea'}
              count={30}
              renderOption={suggestion => (
                <div className={'suggestion'}>
                  <div className={'suggestion__name'}>{suggestion.value}</div>
                  <div className={'suggestion__address'}>
                    {suggestion.data?.address.value}
                  </div>
                </div>
              )}
            />
          </div>
        </div>
        <div className={'education-edit-block__column-field center'}>
          <div className={'label'}>Класс/группа:</div>
          <div className={'input'}>
            <input
              style={notFilled === 'group' ? { border: '1px solid red' } : {}}
              disabled={!isEdit}
              value={group}
              onChange={onChangeGroup}
              className={'input-class'}
              maxLength={256}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
